import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getEcards, getNextCerts, getProfile, getUserInfo, getWechatUser } from '../../reducers/selectors'
import EcardsList from '../../components/EcardsList/EcardsList'
import { UClick } from '../../components/common/utils'
import { loadEcards } from '../../actions'
import './EcardsPage.css'

const EcardsPage = ({ ecards, userInfo, wechatUser, profile, nextCerts, loadEcards }) => {
  useEffect(() => {
    loadEcards()
    UClick('EcardsPage')
  }, [])

  return userInfo && ecards ? (
    <EcardsList wechatUser={wechatUser} ecards={ecards} userInfo={userInfo} profile={profile} nextCerts={nextCerts} />
  ) : null
}

function mapStateToProps(state) {
  return {
    ecards: getEcards(state),
    userInfo: getUserInfo(state),
    wechatUser: getWechatUser(state),
    profile: getProfile(state),
    nextCerts: getNextCerts(state),
  }
}

export default connect(mapStateToProps, { loadEcards })(EcardsPage)
